import axios from "axios";

export const image_base_url = "https://websiteapi.uiplus.in";

//export const image_base_url = "http://localhost:5135";

const api = axios.create({
  
  baseURL: "https://websiteapi.uiplus.in/api",
  //baseURL: "http://localhost:5135/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    // If FormData, remove default JSON header
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;